import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import './styles/jinmai.css'
import './styles/main.css'
import cache from '@/plugins/cache'

Vue.config.productionTip = false

Vue.use(ElementUI)
// 注册缓存插件
Vue.prototype.$cache = cache

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
